import { useRef, useEffect, useState } from "react";
import { Box, Button, HStack, IconButton, Input, Spinner, Text, VStack } from "@chakra-ui/react";
import { HiArrowDown, HiArrowUp } from "react-icons/hi2";
import dayjs from "dayjs";

const LeadNotesTab = ({ notes, isLoading, onAddNote, search, onSearchChange, sortDirection, onToggleSortDirection, highlightId, onHighlightClear }) => {
    const itemRefs = useRef({});
    const [activeHighlight, setActiveHighlight] = useState(highlightId ?? null);

    useEffect(() => {
        if (!activeHighlight) return;
        const el = itemRefs.current[activeHighlight];
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, [notes, activeHighlight]);

    useEffect(() => {
        if (!activeHighlight) return;
        const timer = setTimeout(() => { setActiveHighlight(null); onHighlightClear?.(); }, 2500);
        return () => clearTimeout(timer);
    }, [activeHighlight]);

    return (
        <Box>
            <HStack justify="space-between" mb={4} gap={3} flexWrap="wrap">
                <Text color="text.grey" fontSize="sm" flexShrink={0}>{!isLoading && `Notatki: ${notes.length}`}</Text>
                <HStack gap={2} flex={1} justify="flex-end">
                    <Input placeholder="Szukaj w notatkach..." value={search} onChange={(e) => onSearchChange(e.target.value)} size="sm" maxW="240px" />
                    <IconButton variant="ghost" size="sm" aria-label="Sortowanie" onClick={onToggleSortDirection}>
                        {sortDirection === 'desc' ? <HiArrowDown /> : <HiArrowUp />}
                    </IconButton>
                    <Button size="sm" variant="primary" onClick={onAddNote}>Dodaj notatkę</Button>
                </HStack>
            </HStack>
            {isLoading ? (
                <VStack py={8} align="center"><Spinner color="brand.400" size="sm" /></VStack>
            ) : notes.length === 0 ? (
                <VStack py={10} align="center"><Text color="text.grey" fontSize="sm">{search ? "Brak wyników" : "Brak notatek"}</Text></VStack>
            ) : (
                <VStack gap={3} align="stretch">
                    {notes.map((note) => (
                        <Box
                            key={note.id} ref={el => { itemRefs.current[note.id] = el; }}
                            bg="bg.card" border="1px solid" borderColor={activeHighlight === note.id ? "brand.400" : "border.primary"}
                            borderRadius={12} p={5} transition="border-color 0.5s"
                        >
                            <HStack gap={3} mb={3}>
                                <Box w="36px" h="36px" borderRadius="full" bg="brand.400" display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
                                    <Text color="white" fontWeight={700} fontSize="sm">{(note.authorFullName || "?")[0].toUpperCase()}</Text>
                                </Box>
                                <VStack align="flex-start" gap={0}>
                                    <Text color="white" fontWeight={600} fontSize="sm">{note.authorFullName}</Text>
                                    <Text color="text.grey" fontSize="xs">{dayjs(note.createdAt).format("DD.MM.YYYY HH:mm")}</Text>
                                </VStack>
                            </HStack>
                            <Text color="white" fontSize="sm" lineHeight={1.6}>{note.content}</Text>
                        </Box>
                    ))}
                </VStack>
            )}
        </Box>
    );
};

export default LeadNotesTab;
